<template>
  <div :class="folderClass">
    <div
      v-for="child in files"
      :key="child"
    >
      <a
        href="#"
        @click.prevent="showFile(child)"
      >{{ child }}</a>
    </div>
    <div
      v-for="child in dirs"
      :key="child"
    >
      {{ child }}/
      <OutputFolder
        :node="childNode(child)"
        @show="onShowSubFile(child, $event)"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
div.folder {
  color: #ccc;
  margin-left: 0.3em;
  padding-left: 1.2em;
  border-left: 1px solid #555;

  &.root {
    margin-left: 0;
    border-left: 0;
    padding-left: 0;
  }
}
</style>

<script>
export default {
  name: 'OutputFolder',
  props: {
    node: {
      type: Object,
      required: true
    },
    root: Boolean
  },
  computed: {
    files () {
      const li = Object.keys(this.node).filter((c) => typeof this.node[c] === 'string')
      return li.sort()
    },
    dirs () {
      const li = Object.keys(this.node).filter((c) => typeof this.node[c] !== 'string')
      return li.sort()
    },
    folderClass () {
      return this.root ? 'folder root' : 'folder'
    }
  },
  methods: {
    childNode (child) {
      return this.node[child]
    },
    childIsFolder (child) {
      return typeof this.node[child] !== 'string'
    },
    showFile (child) {
      this.$emit('show', child)
    },
    onShowSubFile (child, subChild) {
      this.$emit('show', `${child}/${subChild}`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/preview/Folder.vue